import { TransactionsMobileColumn } from 'BreetComponents';
import { formatDateTime } from 'BreetHelpers';

import { getTransactionType, type ITableColumnTransactionDetails } from '../../WalletTransactions.helpers';

const TableColumnTransactionDetails = ({ row, onColumnClick }: ITableColumnTransactionDetails) => {
	const accountDetails = getTransactionType(row);

	return (
		<TransactionsMobileColumn.Left
			value={accountDetails}
			date={formatDateTime(row.updatedAt)}
			onClick={onColumnClick}
		/>
	);
};

export default TableColumnTransactionDetails;
